module.exports = __webpack_public_path__ + "files/SPIADI2023.2f71e1991ce5f382e2c897ae19fc4b41.zip";